(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !window.DesignMode) return;
  try {
    
  (() => {
    const headerSection = document.getElementById('shopify-section-header');

    // Handle region selection -> submit localization form
    const form = document.getElementById('HeaderCountryForm');
    if (form) {
      form.addEventListener('click', (e) => {
        const link = e.target.closest('.region-option');
        if (!link) return;
        e.preventDefault();
        const iso = link.getAttribute('data-value');
        const input = form.querySelector('input[name="country_code"]');
        if (iso && input) {
          input.value = iso;
          form.submit();
        }
      });

      // Close <details> after selection
      form.addEventListener('submit', () => {
        const details = form.closest('details');
        if (details && details.open) details.open = false;
      });
    }

    // Update CSS vars for header heights after layout (accounts for the new top bar)
    function setHeaderHeights() {
      const headerHeight = headerSection?.clientHeight || 0;
      const wrapper = headerSection?.querySelector('.header_wrapper');
      const wrapperHeight = wrapper?.clientHeight || headerHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      document.documentElement.style.setProperty('--header-height-without-bottom-nav', wrapperHeight + 'px');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setHeaderHeights);
    } else {
      setHeaderHeights();
    }
    window.addEventListener('resize', setHeaderHeights);
  })();

  } catch(e) { console.error(e); }
})();
})();
